/**
 * seperated from RPG engine by Skeets on 2017/10/30.
 */

var conversationControls = false;
var attackNum            = 0;
var attacking            = false;
var attackWaiting        = false;
var conversationLang     = locale;
var attackCounter        = 0;
var charArray;

var trackGrade    = [];
var trackQuestion = {card: 0, side: 0};


var cards        = [];
var grammars     = [];
var countryFlags = {ja: "Japan", "en": "United-States"};

var specialConversation = null;

$(function() {
  $swapLang = $("#swapLang");
  $swapLang.attr("src", "/img/flag/24/" + countryFlags[conversationLang] + ".png");
  $swapLang.click(function() {
    var char;
    if (conversationLang === "ja") {

      conversationLang = "en";

      char = getConversationCharOrConv(charArray);
      char.conversationShow();

      $(this).attr("src", "/img/flag/24/" + countryFlags[conversationLang] + ".png");


      return true;
    }

    if (conversationLang === "en") {

      conversationLang = "ja";


      char = getConversationCharOrConv(charArray);

      char.conversationShow();


      $(this).attr("src", "/img/flag/24/" + countryFlags[conversationLang] + ".png");
      return true;
    }
  });
});


var charEmoOffset = [
  {x: 103, y: 169}, // 0
  {x: 103, y: 169}, // 1
  {x: 103, y: 160}, // 2
  {x: 105, y: 188}, // 3
  {x: 124, y: 154}, // 4
  {x: 87, y: 178}, // 5
  {x: 84, y: 169}, // 6
  {x: 94, y: 188}, // 7
  {x: 100, y: 158}, // 8
  {x: 73, y: 189}, // 9
  {x: 100, y: 173}, // 10
  {x: 90, y: 140}, // 11
  {x: 99, y: 139}, // 12
  {x: 97, y: 169}, // 13
  {x: 99, y: 169}, // 14
  {x: 90, y: 170}, // 15
  {x: 86, y: 168}, // 16
  {x: 89, y: 186}, // 17
  {x: 87, y: 145}, // 18
  {x: 97, y: 115}, // 19
  {x: 93, y: 164}, // 20
  {x: 85, y: 171}, // 21
  {x: 69, y: 181}, // 22
  {x: 92, y: 167}, // 23
  {x: 107, y: 168}, // 24
  {x: 86, y: 192}, // 25
  {x: 71, y: 169}, // 26
  {x: 80, y: 153}, // 27
  {x: 87, y: 173}, // 28
  {x: 86, y: 180}, // 29
  {x: 75, y: 151}, // 30
  {x: 103, y: 173}, // 31
  {x: 99, y: 175}, // 32
  {x: 94, y: 177}, // 33
  {x: 98, y: 167}, // 34
  {x: 103, y: 142}, // 35
  {x: 106, y: 169}, // 36
  {x: 100, y: 182}, // 37
  {x: 147, y: 170}, // 38
  {x: 95, y: 161}, // 39
  {x: 94, y: 150}, // 40
  {x: 93, y: 175}, // 41
  {x: 120, y: 188}, // 42
  {x: 107, y: 146}, // 43
  {x: 90, y: 180}, // 44
  {x: 110, y: 184}, // 45
  {x: 121, y: 170}, // 46
  {x: 107, y: 168}, // 47
  {x: 103, y: 166}, // 48
  {x: 107, y: 162}, // 49
  {x: 97, y: 175}, // 50
  {x: 68, y: 192}, // 51
  {x: 85, y: 177}, // 52
  {x: 97, y: 165}, // 53
  {x: 73, y: 168}, // 54
  {x: 116, y: 159}, // 55
  {x: 100, y: 173}, // 56
  {x: 82, y: 191}, // 57
  {x: 101, y: 174}, // 58
  {x: 108, y: 185}, // 59
  {x: 82, y: 191}, // 60
  {x: 115, y: 181}, // 61
  {x: 116, y: 163}, // 62
  {x: 82, y: 186}, // 63
  {x: 94, y: 178}, // 64
  {x: 105, y: 190}, // 65
  {x: 98, y: 158}, // 66
  {x: 97, y: 177}, // 67
  {x: 78, y: 172}, // 68
  {x: 101, y: 173}, // 69
  {x: 106, y: 172}, // 70
  {x: 127, y: 174}, // 71
  {x: 114, y: 179}, // 72
  {x: 101, y: 149}, // 73
  {x: 97, y: 172}, // 74
  {x: 92, y: 178}, // 75
  {x: 139, y: 193}, // 76
  {x: 89, y: 178}, // 77
  {x: 101, y: 181}, // 78
  {x: 92, y: 188}, // 79
  {x: 69, y: 169}, // 80
  {x: 69, y: 160}, // 81
  {x: 86, y: 177}, // 82
  {x: 87, y: 157}, // 83
  {x: 103, y: 182}, // 84
  {x: 92, y: 175}, // 85
  {x: 97, y: 191}, // 86
  {x: 81, y: 185}, // 87
  {x: 87, y: 177}, // 88
  {x: 94, y: 173}, // 89
  {x: 101, y: 177}, // 90
  {x: 118, y: 165}, // 91
  {x: 78, y: 193}, // 92
  {x: 97, y: 168}, // 93
  {x: 115, y: 185}, // 94
  {x: 94, y: 169}, // 95
  {x: 88, y: 167}, // 96
  {x: 103, y: 202}, // 97
  {x: 95, y: 181}, // 98
  {x: 87, y: 174}, // 99
  {x: 100, y: 177}, // 100
  {x: 98, y: 177}, // 101
  {x: 95, y: 187}, // 102
  {x: 82, y: 176}, // 103
  {x: 107, y: 177},  // 104
  {x: 102, y: 182},  // 105
  {x: 79, y: 181},  // 106
  {x: 100, y: 192},  // 107
  {x: 95, y: 158},  // 108
  {x: 98, y: 166},  // 109
  {x: 101, y: 165},  // 110
  {x: 103, y: 187},  // 111
  {x: 149, y: 171},  // 112
  {x: 88, y: 180},  // 113
  {x: 101, y: 189},  // 114
  {x: 105, y: 155},  // 115
  {x: 100, y: 186},  // 116
  {x: 103, y: 193},  // 117
  {x: 72, y: 198},  // 118
  {x: 102, y: 173},  // 119
  {x: 102, y: 185},  // 120
  {x: 98, y: 194},  // 121
  {x: 100, y: 174},  // 122
  {x: 95, y: 182},  // 123
  {x: 102, y: 178},  // 124
  {x: 110, y: 193},  // 125
  {x: 94, y: 175},  // 126
  {x: 164, y: 175},  // 127
  {x: 166, y: 176},  // 128
  {x: 102, y: 197},  // 129
  {x: 98, y: 182},  // 130
  {x: 93, y: 182},  // 131
  {x: 95, y: 178},  // 132
  {x: 183, y: 169},  // 133
  {x: 90, y: 185},  // 134
  {x: 101, y: 194},  // 135
  {x: 98, y: 121},  // 136
  {x: 93, y: 118},  // 137
  {x: 94, y: 180},  // 138
  {x: 95, y: 175},  // 139
  {x: 92, y: 166},  // 140
  {x: 103, y: 162},  // 141
  {x: 127, y: 214},  // 142
  {x: 108, y: 155},  // 143
  {x: 105, y: 157},  // 144
  {x: 106, y: 157},  // 145
  {x: 98, y: 198},  // 146
  {x: 92, y: 168},  // 147
  {x: 113, y: 191},  // 148
  {x: 94, y: 168},  // 149
  {x: 105, y: 181},  // 150
  {x: 95, y: 168},  // 151
  {x: 91, y: 175},  // 152
  {x: 97, y: 164},  // 153
  {x: 112, y: 177},  // 154
  {x: 106, y: 173},  // 155
  {x: 89, y: 180},  // 156
  {x: 86, y: 165},  // 157
  {x: 105, y: 168},  // 158
  {x: 104, y: 173},  // 159
  {x: 93, y: 168},  // 160
  {x: 98, y: 200},  // 161
  {x: 97, y: 162},  // 162
  {x: 100, y: 174},  // 163
  {x: 117, y: 170},  // 164
  {x: 118, y: 170},  // 165
  {x: 106, y: 169},  // 166
  {x: 93, y: 172},  // 167
  {x: 104, y: 169},  // 168
  {x: 103, y: 174},  // 169
  {x: 99, y: 163},  // 170
  {x: 97, y: 172},  // 171
  {x: 128, y: 177},  // 172
  {x: 89, y: 168},  // 173
  {x: 133, y: 180},  // 174
  {x: 98, y: 167},  // 175
  {x: 97, y: 187},  // 176
  {x: 93, y: 163},  // 177
  {x: 87, y: 190},  // 178
  {x: 102, y: 191},  // 179
  {x: 90, y: 160},  // 180
  {x: 96, y: 166},  // 181
  {x: 101, y: 168},  // 182
  {x: 122, y: 158},  // 183
  {x: 98, y: 166},  // 184
  {x: 98, y: 174},  // 185
  {x: 93, y: 193},  // 186
  {x: 104, y: 183},  // 187
  {x: 112, y: 151},  // 188
  {x: 95, y: 213},  // 189
  {x: 95, y: 214},  // 190
  {x: 92, y: 176},  // 191
  {x: 73, y: 163},  // 192
  {x: 98, y: 194},  // 193
  {x: 71, y: 159},  // 194
  {x: 102, y: 162},  // 195
  {x: 105, y: 178},  // 196
  {x: 97, y: 165},  // 197
  {x: 98, y: 165},  // 198
  {x: 90, y: 173},  // 199
  {x: 107, y: 177},  // 200
  {x: 107, y: 177}  // 201
];


// emotion is 0-7
// function emo(emotion) {
//   var vert = 0;
//
//   if (emotion > 3) {
//     vert = 1;
//     emotion = emotion - 4;
//   }
//   $("img.emoCharLeft").css({
//     'background-position-x': '-' + emotion * 144 + 'px',
//     'background-position-y': '-' + vert * 144 + 'px'
//   });
// }
var msgBoxFace;
var msgBoxBody;
var charImgWrapper;
var loadOtherPartOfImg;


function showLoad()
{
  $("#charMsgBoxContents").html("読み込んでいます。。。");
}

function showTalk(charImgID, emotion, text, respond)
{

  if (typeof msgBoxFace === "undefined" || msgBoxFace === null) {
    msgBoxFace         = $("img.emoCharLeft");
    msgBoxBody         = $("img.fullCharLeft");
    charImgWrapper     = $(".charImgWrapper");
    loadOtherPartOfImg = false;
  }

  loadOtherPartOfImg = false;
  var vert           = 0;

  if (emotion > 3) {
    vert    = 1;
    emotion = emotion - 4;
  }
  msgBoxFace.css({
    'left'                 : charEmoOffset[charImgID].x + 'px',
    'bottom'               : charEmoOffset[charImgID].y + 'px',
    'background-image'     : 'url(/img/char/' + charImgID + '/emo.png)',
    'background-position-x': '-' + emotion * 144 + 'px',
    'background-position-y': '-' + vert * 144 + 'px'
  });

  if (msgBoxBody.attr("src") !== "/img/char/" + charImgID + "/fullg.png") {
    msgBoxBody.attr("src", "/img/char/" + charImgID + "/fullg.png");

    msgBoxBody.hide().on("load", function() {
      if (loadOtherPartOfImg) {
        loadOtherPartOfImg = false;
        msgBoxFace.show();
        msgBoxBody.show();
      }
      else {
        loadOtherPartOfImg = true;
      }
    });
  }
  else {
    loadOtherPartOfImg = true;
  }


  $('<img/>').attr('src', '/img/char/' + charImgID + '/emo.png').load(function() {
    $(this).remove(); // prevent memory leaks
    msgBoxFace.css('background-image', 'url(/img/char/' + charImgID + '/emo.png)');
    if (loadOtherPartOfImg) {
      loadOtherPartOfImg = false;
      msgBoxFace.show();
      msgBoxBody.show();
    }
    else {
      loadOtherPartOfImg = true;
    }


  });

  var respondHTML = "<div id='charMsgBoxRespond' class='text-center'>";
  var count       = 0;

  if (typeof clearDictionarySuggestions === "function") {
    clearDictionarySuggestions();
  }


  respond.forEach(function(thisRespond) {
    if (typeof thisRespond.events !==
        "undefined" &&
        typeof thisRespond.events[0] !==
        "undefined" &&
        typeof thisRespond.events[0].req !==
        "undefined") {
      if (!checkReqs(thisRespond.events[0].req)) {
        count++;
        return true;
      }
    }

    if (typeof thisRespond.content === "undefined" || thisRespond.content === "undefined") {
      return true;
    }
    switch (count) {
      case 0:
        respondHTML +=
          "<span id='charMsgBoxSideRespondTop' data-responseNum='1' class='charMsgBoxRespond'>" +
          "<span class='innerMsgResponse'>" +
          thisRespond.content +
          "</span>" +
          "</span>";
        break;
      case 1:
        respondHTML += "<span id='charMsgBoxSideRespondBottom' data-responseNum='2' class='charMsgBoxRespond'>" +
                       "<span class='innerMsgResponse'>" +
                       thisRespond.content +
                       "</span>" +
                       "</span>";
        break;
      case 2:
        respondHTML += "<span id='charMsgBoxSideRespondLeft' data-responseNum='3' class='charMsgBoxRespond'>" +
                       "<span class='innerMsgResponse'>" +
                       thisRespond.content +
                       "</span>" +
                       "</span>";
        break;
      case 3:
        respondHTML += "<span id='charMsgBoxSideRespondRight' data-responseNum='4' class='charMsgBoxRespond'>" +
                       "<span class='innerMsgResponse'>" +
                       thisRespond.content +
                       "</span>" +
                       "</span>";
        break;
    }
    count++;


    if (typeof dictionarySuggestion === "function") {
      dictionarySuggestion(thisRespond.content, conversationLang);
    }

  });

  if (typeof dictionarySuggestion === "function") {
    dictionarySuggestion(text);
  }

  respondHTML += "</div>";

  $("#charMsgBoxContents").html("<div class='card-header msgBoxTop'>" + text + "</div>" + respondHTML);

  $("#charMsgBoxWrapper").show();

  var imgPos = $("#charMsgBox").height() - 25;

  var maxPos = $(window).height() - 350;
  if (typeof nav !== "undefined" && nav.mode === "dictionary") {
    maxPos = origWindowHeight - 350;
  }

  if (imgPos > maxPos) {
    imgPos = maxPos;
  }

  charImgWrapper.css("bottom", imgPos);
}


function checkReqs(reqs)
{
  var result = true;
  reqs.forEach(function(thisReq) {
    if (typeof thisReq.operation === "undefined") {
      thisReq.operation = "=";
    }

    switch (thisReq.operation) {
      case "=":
        if (getGameData(thisReq.var) !== parseInt(thisReq.val)) {
          result = false;
        }
        break;
      case ">":
        if (getGameData(thisReq.var) < parseInt(thisReq.val)) {
          result = false;
        }
        break;
      case "<":
        if (getGameData(thisReq.var) > parseInt(thisReq.val)) {
          result = false;
        }
        break;
    }


  });
  return result;
}

$(window).mousedown(function(e) {
  if (attackWaiting) {
    startAttack();
  }
});

$(window).touchend(function(e) {
  if (attackWaiting) {
    startAttack();
    return false;
  }
});


$(window).keydown(function(e) {
  if (typeof mapReady !== "undefined" && !mapReady) {
    return;
  }

  if (loadingAttack || attackWaiting) {
    if (attackWaiting) {
      startAttack();
    }
    return false;
  }

  if (attacking) {

    switch (e.which) {

      case 49:
        chooseAttack(1);
        break;
      case 50:
        chooseAttack(2);
        break;
      case 51:
        chooseAttack(3);
        break;
      case 52:
        chooseAttack(4);
        break;
    }

    return true;
  }

  if (conversationControls) {

    switch (e.which) {

      case 49:
        chooseResponse(1);
        break;
      case 50:
        chooseResponse(2);
        break;
      case 51:
        chooseResponse(3);
        break;
      case 52:
        chooseResponse(4);
        break;

    }
  }

});

function chooseAttack(response)
{
  response = parseInt(response) - 1;

  if (typeof currentQuestion.answers[response].content === "string") {
    attackNum++;
    if (currentQuestion.answers[response].correct) {
      trackGrade.push({card: trackQuestion.card, side: trackQuestion.side, correct: true});
      startAttack();
    }
    else {
      trackGrade.push({card: trackQuestion.card, side: trackQuestion.side, correct: false});
      wrongAnswer();
    }
  }
}

function chooseResponse(response)
{
  response = parseInt(response);
  if (specialConversation !== null) {
    switch (specialConversation[response]) {
      case "battleWin":
        returnToConversationIfInOne(true);
        break;
      case "battleLose":
        returnToConversationIfInOne(false);

        break;

    }
    specialConversation = null;
    return true;
  }
  var convChar  = getConversationCharOrConv(charArray);
  var responses = convChar.conversation[conversationLang][convChar.currentConversation].respond;
  switch (response) {
    case 1:
      if (typeof responses[0].content === "string") {
        convChar.handleConv(responses, 0);
        return;
      }
      break;
    case 2:
      if (typeof responses[1].content === "string") {
        convChar.handleConv(responses, 1);
        return;
      }
      break;
    case 3:
      if (typeof responses[2].content === "string") {
        convChar.handleConv(responses, 2);
        return;
      }
      break;
    case 4:
      if (typeof responses[3].content === "string") {
        convChar.handleConv(responses, 3);
        return;
      }
      break;

  }
}

// End Controls


$(document).on("click", ".charMsgBoxRespond", function() {
  var responseNum = $(this).attr("data-responsenum");
  // var keyUpE = jQuery.Event("keyup");
  if (attacking) {
    chooseAttack(responseNum);
  }
  else {
    chooseResponse(responseNum);
  }
});

var loadingAttack = false;

function attack(response)
{
  conversationControls   = true;
  currentQuestionCardNum = 0;

  attackNum = 0;

  $("#swapLang").css("visibility", "hidden");
  currentAttack = response;
  numWrong      = 0;

  loadingAttack = true;
  showLoad();

  $.ajax({
    type: "POST",
    url : "/getBattle",
    data: {

      attack: currentAttack.attack

    }
  }).done(function(response) {


    cards     = shuffle(response.cards);
    grammars  = shuffle(response.grammars);
    attacking = true;


    startAttack();

  });


}

var currentQuestion = {};
var currentAttack   = {};
var numWrong        = 0;

function startAttack()
{

  loadingAttack = false;
  if (!$("#hitpoints").length) {
    $("#charMsgBox")
      .append("<div id='hitpoints' style='color: red; position: absolute; top: 10px; right: 15px;'><i class='fas fa-heart hitpoint' data-num='3'></i>&nbsp;" +
              "<i class='fas fa-heart hitpoint' data-num='2'></i>&nbsp;<i class='fas fa-heart hitpoint' data-num='1'></i></div>");
  }
  attackCounter   = 0;
  attackWaiting   = false;
  var attack      = currentAttack.attack;
  var alreadyLost = false;

  if (numWrong >= 3) {
    showBattleResults(false);
    alreadyLost = true;
  }

  if (!alreadyLost && (attackNum >= attack.count || typeof cards[0] === "undefined")) {
    showBattleResults(true);
  }

  if (attacking == false) {

    $.ajax({
      type: "POST",
      url : "/postBattle",
      data: {
        data: trackGrade
      }
    });


    trackGrade = [];


    return;
  }


  currentQuestion = getQuestion(attack);


  showTalk(0, 0, currentQuestion.question, currentQuestion.answers);


}

function showBattleResults(win)
{
  attacking = false;

  var close    = "Close";
  var congrats = "Good job.";
  var bummer   = "You lose.";


  if (conversationLang === "ja") {

    close    = "閉じる";
    congrats = "よくできました！";
    bummer   = "残念！";
  }
  var respond = [{"content": close}, {}, {}, {}];
  if (win) {
    specialConversation = ["battleWin", "battleWin", "battleWin", "battleWin"];
  }
  else {
    specialConversation = ["battleLose", "battleLose", "battleLose", "battleLose"];
  }

  if (win) {
    showTalk(0, 0, congrats, respond);
  }
  else {
    showTalk(0, 0, bummer, respond);
  }
}

function returnToConversationIfInOne(win)
{
  convChar = getConversationCharOrConv(charArray);
  if (typeof convChar.conversationShow === "function") {
    if (win) {
      convChar.currentConversation = currentAttack.next;
    }
    else {
      convChar.currentConversation = currentAttack.lose;
    }

    convChar.conversationShow();
  }
  else {
    $("#charMsgBoxWrapper").hide();
    conversationControls = false;
  }

  $("#swapLang").css("visibility", "visible");


}


function highlightCorrectAnswer()
{
  var count = 0;
  currentQuestion.answers.forEach(function(thisAnswer) {
    if (thisAnswer.correct) {
      switch (count) {
        case 0:
          $("#charMsgBoxSideRespondTop").addClass("correctAnswerDisp");
          break;
        case 1:
          $("#charMsgBoxSideRespondBottom").addClass("correctAnswerDisp");
          break;
        case 2:
          $("#charMsgBoxSideRespondLeft").addClass("correctAnswerDisp");
          break;
        case 3:
          $("#charMsgBoxSideRespondRight").addClass("correctAnswerDisp");
          break;
      }
      return;
    }

    attackWaiting = true;

    count++;
  });
}


function wrongAnswer()
{
  numWrong++;

  var hitpoint1 = $(".hitpoint[data-num=1]");
  var hitpoint2 = $(".hitpoint[data-num=2]");
  var hitpoint3 = $(".hitpoint[data-num=3]");
  if (numWrong >= 1) {
    hitpoint1.attr("data-prefix", "far");
  }
  if (numWrong >= 2) {
    hitpoint1.attr("data-prefix", "far");
    hitpoint2.attr("data-prefix", "far");
  }
  if (numWrong >= 3) {
    hitpoint1.attr("data-prefix", "far");
    hitpoint2.attr("data-prefix", "far");
    hitpoint3.attr("data-prefix", "far");
  }

  highlightCorrectAnswer();
}

function getConversationCharOrConv(charArray)
{
  if (typeof getConversationChar === "function") {
    var convChar = getConversationChar(charArray);
    if (convChar !== false) {
      return convChar;
    }
  }

  return currentMapConversation;
}

var currentMapConversation = {};

function MapConversation(charImg, conv)
{
  this.charImgID           = charImg;
  this.conversation        = conv;
  this.currentConversation = 0;

  this.handleConv       = function(responses, num) {
    handleConv(responses, num, this);
  };
  this.conversationShow = function() {
    if (currentMapConversation !== this) {
      currentMapConversation = this;
    }
    $("#swapLang").css("visibility", "visible");
    if (!isNaN(this.currentConversation)) {
      this.currentConversation = parseInt(this.currentConversation);
    }
    if (typeof this.currentConversation === "string") {

      conversationControls     = false;
      this.currentConversation = 0;
      $("#charMsgBoxWrapper").hide();
      $(".hideOnConv").show();
      return true;
    }

    $(".hideOnConv").hide();
    showTalk(this.charImgID,
      this.conversation[conversationLang][this.currentConversation].emo,
      this.conversation[conversationLang][this.currentConversation].content,
      this.conversation[conversationLang][this.currentConversation].respond);
  };
}

function handleEvents(theseEvents)
{
  theseEvents.forEach(function(event) {
    var passedReqs = checkReqs(event.req);


    if (passedReqs) {
      event.action.forEach(function(action) {
        handleAction(action);
      });
    }

  });
}

function handleConv(responses, num, context)
{
  var thisRespond = responses[num];

  if (typeof thisRespond.events !==
      "undefined" &&
      typeof thisRespond.events[0] !==
      "undefined" &&
      typeof thisRespond.events[0].req !==
      "undefined") {
    if (!checkReqs(thisRespond.events[0].req)) {
      return true;
    }
  }

  if (typeof thisRespond.events === "object" && thisRespond.events !== null) {
    handleEvents(thisRespond.events);
  }

  if (typeof responses[num].attack === "object" && responses[num].attack !== null) {
    attack(responses[num]);
  }
  else {
    context.currentConversation = responses[num].next;
    context.conversationShow();
  }


}


setInterval(function() {
  msgBoxLoop();
}, 20);

function msgBoxLoop()
{
  if (attacking && !attackWaiting) {
    attackCounter++;
    if (attackCounter > currentAttack.attack.time) {
      wrongAnswer();
      trackGrade.push({card: trackQuestion.card, side: trackQuestion.side, correct: true});
    }

    if (!$("#attackTimer").length) {
      $("#charMsgBox")
        .append("<div id='attackTimer' style='background-color: grey; width: 75%; height: 15px; margin: auto; border: 1px solid black;'>" +
                "<div id='attackTimerInner' style='background-color: blue; height: 13px;'></div></div>");
    }

    var newWidth = ((attackCounter / currentAttack.attack.time) * 100);

    if (newWidth > 100) {
      newWidth = 100;
    }

    $("#attackTimerInner").css("width", newWidth + "%");

  }
  else if (!attacking) {
    $("#attackTimer").remove();
    $("#hitpoints").remove();
  }
}



